<div class="progress-state-informer" [ngClass]="informerColorClass">
  <mat-icon *ngIf="icon" class="progress-state-informer-icon">{{ icon }}</mat-icon>

  <span [innerHTML]="text"></span>

  <span *ngIf="informerDate">{{ informerDate | np_to_date_format | date :"dd.MM.yyyy HH:mm:ss" }}</span>
</div>
